import React from 'react';
import PropTypes from 'prop-types';
import GiftCardDisplay from '../../components/GiftCardDisplay';
import Header from '../../components/Layout/Header';
import LayoutWrapper from '../../components/LayoutWrapper';

const Home = (props) => {
	const { siteId } = props;

	return (
		<LayoutWrapper>
			<Header siteId={siteId} />
			<GiftCardDisplay />
		</LayoutWrapper>
	);
};

Home.propTypes = {
	siteId: PropTypes.number
};

export default Home;
